var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5303 0.46967C12.2374 0.176777 11.7626 0.176777 11.4697 0.46967L6.6967 5.24264C6.40381 5.53553 6.40381 6.01041 6.6967 6.3033C6.98959 6.59619 7.46447 6.59619 7.75736 6.3033L12 2.06066L16.2426 6.3033C16.5355 6.59619 17.0104 6.59619 17.3033 6.3033C17.5962 6.01041 17.5962 5.53553 17.3033 5.24264L12.5303 0.46967ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H12H11.25ZM12 1H11.25V17H12H12.75V1H12Z",
    fill: "#6C6859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13V17.6C1 19.8402 1 20.9603 1.43597 21.816C1.81947 22.5686 2.43139 23.1805 3.18404 23.564C4.03968 24 5.15979 24 7.4 24H16.6C18.8402 24 19.9603 24 20.816 23.564C21.5686 23.1805 22.1805 22.5686 22.564 21.816C23 20.9603 23 19.8402 23 17.6V13",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.18720790ae2326f8b135bf5f1af2c136.svg";
export { ForwardRef as ReactComponent };